














































import Vue from "vue";

export default Vue.extend({
    props: {
        row1cols1: {
            type: String,
            default: "auto",
        },
        row1cols2: {
            type: String,
            default: "auto",
        },
        row2cols1: {
            type: String,
            default: "auto",
        },
    },
});
